import '../index.scss';
import { useMemo, FC } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
} from '@material-ui/core';
import { Select } from '@sharedComponents/DesignSystem/Inputs';
import { DownloadFormats } from '@constants/downloadFormats';
import { translate } from '@utils';
import { DownloadOptions } from './modal.utils';
import { TranslationKey } from '@types';
import { useSelector } from 'react-redux';
import { submissionFormDownloadExtensionsSelector } from '@selectors/submission';

interface DownloadModalProps {
  format: DownloadFormats;
  isDisabledConfirmationButton: boolean;
  contentName: TranslationKey;
  [key: string]: any;
  // TODO: Define the rest of properties
}

export const DownloadModal: FC<DownloadModalProps> = ({
  handleCancel,
  handleConfirmation,
  open,
  contentName,
  format,
  handleChangeFormat,
  value,
  onChange,
  isDisabledConfirmationButton,
}) => {
  const submissionFormDownloadExtensions = useSelector(submissionFormDownloadExtensionsSelector);

  const optionsList = useMemo(
    () => DownloadOptions.filter(({ value }) => submissionFormDownloadExtensions?.includes(value)),
    [open, submissionFormDownloadExtensions]
  );

  return (
    <Dialog className="download-modal" open={open} keepMounted onClose={handleCancel}>
      <DialogTitle>{translate('download_modal_template_name')}</DialogTitle>
      <DialogContent>
        <DialogContentText className="modal-text-field-title">
          {translate('template_input_name')}
        </DialogContentText>
        <TextField
          className="modal-text-field"
          value={value}
          onChange={onChange}
          placeholder={translate(contentName)}
        />
        <Select
          options={optionsList}
          value={format}
          handleChange={handleChangeFormat}
          placeholder={translate('format')}
          className="format-select"
          testId="select-format"
          disabled={optionsList.length === 1}
        />
      </DialogContent>
      <DialogActions className="modal-actions">
        <Button
          onClick={handleConfirmation}
          className="actions-button download"
          disabled={!format || isDisabledConfirmationButton}
          disableRipple
          data-testid="download-button"
        >
          {translate('download')}
        </Button>
        <Button
          onClick={handleCancel}
          className="actions-button cancel"
          disableRipple
          data-testid="cancel-button"
        >
          {translate('cancel')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
